<template>
  <div>
    <!-- Route Making Dedicated View (role = 3) -->
    <route-making-trips v-if="isRouteMaking"></route-making-trips>

    <!-- Super Admin (role = 0) Old Trips Screen (Unchanged) -->
    <v-card v-else>
      <v-card-title>
        <v-icon color="primary"> mdi-bus-clock </v-icon>
        <span class="px-2">{{$t('trips')}}</span>
        <v-spacer></v-spacer>
        <create-button :text="$t('create_new_trip')" @create="createTrip"></create-button>
        <activation-tool-tip model="trips"></activation-tool-tip>
      </v-card-title>

      <v-card-text class="pb-0">
        <v-text-field
          v-model="search"
          :label="$t('search_trips')"
          prepend-inner-icon="mdi-magnify"
          clearable
          outlined
          dense
          hide-details
          class="mb-3"
          @input="onSearchInput"
          @click:clear="onSearchClear"
        ></v-text-field>
      </v-card-text>

      <!-- tabs -->
      <v-tabs v-model="active_tab" show-arrows class="my-2">
        <v-tab v-for="tab in translatedTabs" :key="tab.idx">
          <v-icon size="20" class="me-3">
            {{ tab.icon }}
          </v-icon>
          <span>{{ tab.title }}</span>
          <v-chip
            v-if="tab.idx === 4 && cancelledCount > 0"
            color="error"
            x-small
            label
            class="ms-2 font-weight-bold"
          >
            {{ cancelledCount }}
          </v-chip>
        </v-tab>
      </v-tabs>
    <!-- tabs item -->
    <v-tabs-items v-model="active_tab">
      <!-- active -->
      <v-tab-item>
        <trips-table
        :loading="isLoading"
        :trips="activeTrips" :mode=1 @trashRestoreTrip="trashRestoreTrip" @refreshTrips="loadTrips"></trips-table>
      </v-tab-item>

      <!-- paused parent trips -->
      <v-tab-item>
        <trips-table
        :loading="isLoading"
        :trips="pausedTrips" :mode=4 @refreshTrips="loadTrips"></trips-table>
      </v-tab-item>

      <!-- trashed -->
      <v-tab-item>
        <trips-table
        :loading="isLoading"
        :trips="trashedTrips" :mode=3 @trashRestoreTrip="trashRestoreTrip" @refreshTrips="loadTrips"></trips-table>
      </v-tab-item>

      <!-- late start requests -->
      <v-tab-item>
        <late-start-requests></late-start-requests>
      </v-tab-item>

      <!-- cancelled trips -->
      <v-tab-item>
        <cancelled-trips @updateCount="cancelledCount = $event"></cancelled-trips>
      </v-tab-item>

      <!-- suspended (date exclusions) -->
      <v-tab-item>
        <trips-table
        :loading="isLoading"
        :trips="suspendedTrips" :mode=2 @deleteSuspension="deleteSuspension" @refreshTrips="loadTrips"></trips-table>
      </v-tab-item>

    </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import tripsTable from './trips-table.vue';
import LateStartRequests from './late-start-requests.vue';
import CancelledTrips from './cancelled-trips.vue';

import EventBus from './eventBus';

import {
  mdiStopCircleOutline,
  mdiPlayCircleOutline,
  mdiTrashCan,
  mdiDeleteRestore,
  mdiAirplane,
  mdiMotionPause,
  mdiClockAlertOutline,
  mdiCancel,
  mdiPauseCircle
} from "@mdi/js";

import ActivationToolTip from "@/components/ActivationToolTip";
import CreateButton from "@/components/CreateButton";
import auth, { getUserRole } from '@/services/AuthService';
import RouteMakingTrips from './RouteMakingTrips.vue';

export default {
  components: {
    tripsTable,
    LateStartRequests,
    CancelledTrips,
    ActivationToolTip,
    CreateButton,
    RouteMakingTrips,
  },
  data() {
    return {
      isRouteMaking: getUserRole() === 3,
      activeTrips: [],
      pausedTrips: [],
      trashedTrips: [],
      suspendedTrips: [],
      isLoading: false,
      search: "",
      searchTimeout: null,
      cancelledCount: 0,
      tabs: [
        { idx: 0, title: "active", icon: mdiAirplane },
        { idx: 1, title: "الرحلات المتوقفة", icon: mdiPauseCircle },
        { idx: 2, title: "trashed", icon: mdiTrashCan },
        { idx: 3, title: "طلبات البدء المتأخر", icon: mdiClockAlertOutline },
        { idx: 4, title: "الرحلات الملغاة", icon: mdiCancel },
        { idx: 5, title: "suspended", icon: mdiMotionPause },
      ],
      active_tab: null,
      icons: {
        mdiStopCircleOutline,
        mdiPlayCircleOutline,
        mdiTrashCan,
        mdiDeleteRestore,
        mdiAirplane,
        mdiCancel
      },
    };
  },
  watch: {
    active_tab: function (newVal, oldVal) {
      localStorage.tabIdxTrips = newVal;
    },
  },
  computed: {
    translatedTabs() {
      return this.tabs.map(tab => ({
        ...tab,
        title: (tab.title === "active" || tab.title === "suspended" || tab.title === "trashed") ? this.$t(tab.title) : tab.title
      }));
    },
  },
  mounted() {
    if (!this.isRouteMaking) {
      this.active_tab = parseInt(localStorage.tabIdxTrips) || 0;
      this.loadTrips();
    }
  },
  created () {
    var self = this;

    EventBus.$on('DELETE_SUSPENSION', function (suspension, index) {
      self.deleteSuspension(suspension, index)
    });
  },
  methods: {
    onSearchInput() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.loadTrips();
      }, 400);
    },
    onSearchClear() {
      this.search = "";
      this.loadTrips();
    },
    tConvert(time) {
      if (time == null) {
        return null;
      }
      time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)/) || [time];

      if (time.length > 1) {
        time = time.slice(1);
        time[5] = +time[0] < 12 ? " AM" : " PM";
        time[0] = +time[0] % 12 || 12;
      }
      return time.join("");
    },
    displayRoute(route_id) {
      this.$router.push({
        name: "view-route",
        params: { route_id: route_id },
      });
    },

    deleteSuspension(suspension_id, index) {
      this.$swal
        .fire({
          title: this.$t("remove_suspension"),
          text: this.$t("confirm_remove_suspension"),
          icon: "success",
          showCancelButton: true,
          confirmButtonText: this.$t("yes"),
          cancelButtonText: this.$t("cancel"),
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.deleteSuspensionServer(suspension_id, index);
          }
        });
    },

    deleteSuspensionServer(suspension_id, index) {
      this.isSubmit = true;
      axios
        .delete(`/trips/remove-suspension/${suspension_id}`)
        .then((response) => {
          this.isSubmit = false;
          if(index != null)
            this.suspendedTrips.splice(index, 1);
          this.$notify({
            title: this.$t("Success"),
            text: this.$t("suspension_removed"),
            type: "success",
          });
          if(index == null)
          {
            this.$router.go(-1);
          }
        })
        .catch((error) => {
          this.isSubmit = false;
          this.$notify({
            title: "Error",
            text: "Error",
            type: "error",
          });
        });
    },

    trashRestoreTrip(trip, index) {
      this.$swal
        .fire({
          title: (trip.status_id != 1 ? this.$t("restore_trip") : this.$t("trash_trip")),
          text: (trip.status_id != 1 ? this.$t("confirm_restore_trip") : this.$t("confirm_trash_trip")),
          icon: trip.status_id != 1 ? "success" : "error",
          showCancelButton: true,
          confirmButtonText: this.$t("yes"),
          cancelButtonText: this.$t("cancel"),
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.trashRestoreTripServer(trip, index);
          }
        });
    },
    trashRestoreTripServer(trip, index) {
      this.isSubmit = true;
      axios
        .post("/trips/trash-restore", {
          trip_id: trip.id,
        })
        .then((response) => {
          this.isSubmit = false;
          if(trip.status_id == 1)
          {
            trip.status_id == 3;
            this.activeTrips[index].status_id = 3;
            this.activeTrips.splice(index, 1);
            this.trashedTrips.push(trip);
          }
          else
          {
            trip.status_id == 1;
            this.trashedTrips[index].status_id = 1;
            this.activeTrips.push(trip);
            this.trashedTrips.splice(index, 1);
          }
          this.$notify({
            title: this.$t("Success"),
            text: (trip.status_id != 1 ? this.$t("trip_trashed") : this.$t("trip_restored")),
            type: "success",
          });
        })
        .catch((error) => {
          this.isSubmit = false;
          this.$notify({
            title: "Error",
            text: "Error",
            type: "error",
          });
        });
    },

    loadTrips() {
      this.isLoading = true;
      this.activeTrips = [];
      this.pausedTrips = [];
      this.trashedTrips = [];
      this.suspendedTrips = [];
      let params = {};
      if (this.search) {
        params.search = this.search;
      }
      axios
        .get(`/trips/all`, { params })
        .then((response) => {
          this.activeTrips = response.data.activeTrips || [];
          this.pausedTrips = response.data.pausedTrips || [];
          this.trashedTrips = response.data.trashedTrips || [];
          this.suspendedTrips = response.data.suspendedTrips || [];
        })
        .catch((error) => {
          this.$notify({
            title: "Error",
            text: this.$t("error_retrieving_trips"),
            type: "error",
          });
          console.log(error);
          this.$swal("Error", error.response ? error.response.data.message : "Error", "error");
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    createTrip() {
      this.$router.push({
        name: "create-trip",
      });
    },
  },
};
</script>
